var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2020_2679",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2020_2679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 10C2 8.33335 2.37083 6.80418 3.1125 5.41251C3.85417 4.02085 4.85 2.86668 6.1 1.95001L7.275 3.55001C6.275 4.28335 5.47917 5.20835 4.8875 6.32501C4.29583 7.44168 4 8.66668 4 10H2ZM20 10C20 8.66668 19.7042 7.44168 19.1125 6.32501C18.5208 5.20835 17.725 4.28335 16.725 3.55001L17.9 1.95001C19.15 2.86668 20.1458 4.02085 20.8875 5.41251C21.6292 6.80418 22 8.33335 22 10H20ZM4 19V17H6V10C6 8.61668 6.41667 7.38751 7.25 6.31251C8.08333 5.23751 9.16667 4.53335 10.5 4.20001V3.50001C10.5 3.08335 10.6458 2.72918 10.9375 2.43751C11.2292 2.14585 11.5833 2.00001 12 2.00001C12.4167 2.00001 12.7708 2.14585 13.0625 2.43751C13.3542 2.72918 13.5 3.08335 13.5 3.50001V4.20001C14.8333 4.53335 15.9167 5.23751 16.75 6.31251C17.5833 7.38751 18 8.61668 18 10V17H20V19H4ZM12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1958 21.0208 10 20.55 10 20H14C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0208 21.8042 12.55 22 12 22ZM8 17H16V10C16 8.90001 15.6083 7.95835 14.825 7.17501C14.0417 6.39168 13.1 6.00001 12 6.00001C10.9 6.00001 9.95833 6.39168 9.175 7.17501C8.39167 7.95835 8 8.90001 8 10V17Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsActive);
export default __webpack_public_path__ + "static/media/notifications_active.90590c3e66731c47623b50ce60c4f3da.svg";
export { ForwardRef as ReactComponent };